<template>
  <div>
    <div class="shop_top">
      <shop-top :subnav_show="subnav_show"></shop-top>
    </div>
    <div class="width_center_1200">
      <banner :list="banner_list"></banner>
      <div class="notify">
        <el-carousel height="38px" direction="vertical">
          <el-carousel-item v-for="item in noticeList" :key="item.id">
            <svg-icon iconClass="notice" />
              <div class="cont" @click="handleNotice(item)">
                <span>{{ item.title }}</span>
              </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="shop_content width_center_1200">
        <!-- 优惠券 -->
        <coupon :list="couponList"></coupon>
        <!-- 月卡入口 -->
        <div class="ad-list">
          <el-image v-for="item in adList" :key="item.id" :src="item.advImg" fit="cover" @click="$router.push(item.advUrl)" />
        </div>
        <!-- 活动商品 -->
        <activity-products></activity-products>
        <!-- 推荐商品 -->
        <recommended-products></recommended-products>
      </div>
      <merchant-promise></merchant-promise>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import ShopTop from '@/components/ShopHead/index'
import banner from './components/banner'
import RecommendedProducts from './components/recommended'
import ActivityProducts from './components/activity'
import ShopFoot from '@/components/ShopFoot/index'
import MerchantPromise from '@/components/MerchantPromise/index'
import Coupon from '@/components/Coupon/index'
import { getadvList, gethomenotelist } from '@/api/home'
import { getcouponlist } from '@/api/coupon'
export default {
  components: {
    ShopTop,
    banner,
    RecommendedProducts,
    ActivityProducts,
    MerchantPromise,
    ShopFoot,
    Coupon
  },
  data() {
    return {
      // notice: [],
      banner_list: [], // 幻灯片
      subnav_show: false,
      couponList: [],
      noticeList: [],
      adList: []
    }
  },
  methods: {
    init() {
      getadvList({
        platform: 3,
        advPosition: 1
      }).then(({ data }) => {
        this.banner_list = data
      })
      getadvList({
        platform: 3,
        advPosition: 6
      }).then(({ data }) => {
        this.adList = data
      })
      // getagreement({
      //   keyword: 'homeNotice'
      // }).then(({ data }) => {
      //   this.notice = data.title
      // })
      getcouponlist().then(({ data }) => {
        this.couponList = data
      })
      gethomenotelist().then(({ data }) => {
        this.noticeList = data
      })
    },
    handleNotice(item) {
      this.$router.push(`/parse?id=${item.id}`)
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 监听滚动条
    window.addEventListener(
      'scroll',
      () => {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop > 20) {
          this.subnav_show = false
        } else {
          this.subnav_show = true
        }
      },
      true
    )
  }
}
</script>
<style lang="scss" scoped>
.shop_content {
  background: #f5f5f5;
  padding: 0 0 30px 0;
}
.notify {
  // display: flex;
  // align-items: center;
  height: 38px;
  background: rgba(236, 146, 33, 0.05);
  border: 1px solid rgba(236, 146, 33, 0.5);
  border-radius: 4px;
  margin: 15px 0;
  /deep/ .el-carousel__item {
    display: flex;
    align-items: center;
  }
  .svg-icon {
    width: 16px;
    height: 16px;
    margin: 0 10px;
  }
  .cont {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    cursor: pointer;
    span {
      color: #ec9221;
      font-size: 14px;
    }
  }
}
/deep/ .leftbar {
  height: 466px;
}
.coupon-list {
  margin-top: -10px;
  margin-bottom: 6px;
}
.ad-list {
  padding-bottom: 20px;
  /deep/ .el-image {
    width: 100%;
    margin-bottom: 10px;
    cursor: pointer;
    img {
      border-radius: 12px;
    }
  }
}
</style>